<template>
  <div class="question_detail">
    <div class="ques_anw">
      <div class="inner">
        <ul class="ques">
          <li>问</li>
          <li>{{que_anw.title}}?</li>
        </ul>
        <ul class="anw">
          <li>答</li>
          <li>{{que_anw.content}}</li>
        </ul>
      </div>
    </div>
    <div class="divide"></div>
    <div class="question">
      <div class="title">相关推荐问题</div>
      <ul>
        <li v-for="(item,index) in rec_que_list" :key="index" @click="getRecIndex(item.id,index)">
          <div>
            <span>{{item.title}}？</span>
            <span><img src="../assets/images/arrow.png" alt=""/></span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "QuestionDetail",
    data:function(){
      return{
        //问答
        que_anw:[],
        //相关推荐问题
        rec_que_list:[],
        //上页点击常见问题传过来的参数
        problemId:1,
        //相关问题分页的当前页
        currentPage:null
      }
    },
    mounted:function(){

      this.uid = this.$route.query.uid;
      //由于从上页接收过来的参数problemId是一个数组,取里面的属性problemId
      this.problemId=this.$route.params.problemId;
      //获取当前页面的url
      // var url=window.location.href;
      // console.log(url)
      this.getQuestion();
    },
    methods:{
      //获取具体问题数据
      getQuestion:function(){
        this.$ajax.post('/problem/findOne',{
            items: 10,
            problemId:this.problemId,
            base:{
              uid:"",
            }
        }).then(res=>{
          window.console.log(res);
          this.que_anw=res.data.data.problem;
          // console.log(this.que_anw)
          this.rec_que_list=res.data.data.relatedProblemList;
          // console.log(this.rec_que_list)
        }).catch(err=>{
          window.console.log(err);
        })
      },
      //点击相关推荐问题
      getRecIndex:function(id,index){
        //把相关推荐问题的problemId参数传递给下一个页面便于获取数据
        this.problemId=id;
        //点击相关问题列表时把当前点击下标赋值给currentPage
        this.currentPage=index;
        this.$router.replace({
          path: `/questionDetail/${this.problemId}`,
        });
        this.getQuestion();
      }
    }
  }
</script>

<style lang="scss" type="text/scss">
  .question_detail{
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    .ques_anw{
      width: 100%;
      background: #fff;
      padding-top: 6.666667vw;
      padding-bottom: 8vw;
    }

    .divide{
      width: 100%;
      height: 2.4vw;
      background: #f6f7f8;
    }

    .ques_anw .inner{
      width: 94%;
      margin: 0 auto;
    }
    .ques_anw .ques{
      display: flex;
      align-items: center;
      margin-bottom: 4vw;
    }
    .ques_anw .anw{
      display: flex;
      justify-content: space-between;
    }

    .ques_anw .inner ul{
      display: flex;
    }

    .ques_anw .ques li:first-child{
      width: 6vw;
      height: 6vw;
      border-radius: 1.333333vw;
      color: #fff;
      font-size: 2.666667vw;
      background: #5E76FF;
      margin-right: 3.066667vw;
      text-align: center;
      line-height: 6vw;
    }

    .ques_anw .ques li:last-child{
      color: #333;
      font-size: 3.733333vw;
      font-weight: bold;
      width: 90vw;
    }

    .ques_anw .anw li:first-child{
      width: 6vw;
      height: 6vw;
      border-radius: 1.333333vw;
      color: #fff;
      font-size: 2.666667vw;
      background: #FFAA18;
      margin-right: 3.066667vw;
      text-align: center;
      line-height: 6vw;
    }

    .ques_anw .anw li:last-child{
      color: #333;
      font-size: 3.733333vw;
      width: 90vw;
    }

    .question{
      width: 94%;
      margin: 0 auto;
      background: #fff;
      padding-top: 8vw;
      font-size: 3.733333vw;
    }

    .question .title{
      margin-bottom: 2vw;
      font-weight: bold;
    }

    .question ul li div{
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 14.933333vw;
      border-bottom: 0.133333vw solid #eee;
      color: #666;
      /* font-size: 3.733333vw; */
    }
    .question ul li a img{
      width: 1.5vw;
    }
  }
</style>